import script from "./GlobusDropdownObject.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobusDropdownObject.vue?vue&type=script&setup=true&lang=js"

import "./GlobusDropdownObject.vue?vue&type=style&index=0&id=480c708a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-480c708a"]])

export default __exports__